/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Verify_LabelInputs */



/**
* | output |
* | --- |
* | "Verify the output after writing (reads both files again)" |
*
* @param {Embed_Captions_Local_Verify_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_verify_label = /** @type {((inputs?: Embed_Captions_Local_Verify_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Verify_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérifiez le résultat après l'écriture (relecture des deux fichiers).")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfen Sie die Ausgabe nach dem Schreiben (lesen Sie beide Dateien erneut).")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verificare l'output dopo la scrittura (leggendo nuovamente entrambi i file).")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте результат после записи (повторно прочтите оба файла).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verifica el resultado después de escribir (lee ambos archivos de nuevo).")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("写入后验证输出（再次读取两个文件）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書き込み後に出力結果を確認します（両方のファイルを再度読み込みます）。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिखने के बाद आउटपुट की जाँच करें (दोनों फ़ाइलों को दोबारा पढ़ें)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique a saída após a gravação (lê ambos os arquivos novamente).")
	return /** @type {LocalizedString} */ ("Verify the output after writing (reads both files again)")
});